export default {
  back: "返回",
  pageTitle: "嘉实多汽车膜报价",
  subtitleFlow: "即选即算",
  loading: "正在加载报价数据…",
  reload: "重新加载",
  loadFailed: "数据加载失败",
  completeStepFirst: "请先完成当前步骤",

  steps: {
    brand: "1. 选品牌",
    product: "2. 选产品",
    parts: "3. 选部位",
    quote: "4. 看报价",
  },

  stepMeta: {
    brand: { title: "选品牌", desc: "车型" },
    product: { title: "选产品", desc: "车衣型号" },
    parts: { title: "选部位", desc: "装贴范围" },
    quote: { title: "看报价", desc: "参考价格" },
  },

  selectBrand: "选择品牌",
  selectedBrand: "已选品牌",
  changeBrand: "更换",
  modelSection: "{brand} · 车型",
  searchModel: "搜索车型",
  modelBrowseHint: "搜索或浏览该品牌旗下车型",
  noModels: "暂无车型数据",
  noModelsQuery: "未找到「{query}」相关车型",
  bodyTypeDetected: "已识别车身类型：{type}",

  selectProduct: "选择产品",
  fullInstallRef: "整车装贴参考价",

  selectParts: "选择装贴部位",
  selectPartsHint: "勾选需要装贴的车身部位，支持多选",
  partsSelected: "已选 {count} 个装贴部位",
  partsList: "部位清单",
  selectAll: "全选",
  deselectAll: "取消全选",

  partialQuote: "局部贴膜参考报价",
  disclaimer: "仅供参考，非合同价",
  vehicleInfo: "车辆信息",
  brandModel: "品牌车型",
  bodyType: "车身类型",
  productCode: "产品型号",
  installParts: "装贴部位",

  prev: "上一步",
  next: "下一步",
  viewQuote: "查看报价",
  restart: "重新报价",
  adjustParts: "调整部位",

  searchBrand: "搜索品牌，如 大众、宝马",
  brandBrowseHint: "按拼音首字母浏览，支持搜索新能源品牌",
  noBrands: "未找到「{query}」相关品牌",

  bodyTypes: {
    轿车: "轿车",
    SUV: "SUV",
    跑车: "跑车",
    MPV: "MPV",
  },

  productTier: {
    flagship: "旗舰",
    premium: "高端",
    quality: "品质",
    bestseller: "畅销",
    balanced: "均衡",
    entry: "入门",
    default: "车衣",
  },

  productNames: {
    T9: "统御(T9-1501)漆面保护膜",
    A8: "昂御(A8-1401)漆面保护膜",
    E7: "雅御(E7-1301)漆面保护膜",
    GM7: "佳御(哑光)(GM7-1102)漆面保护膜",
    GH7: "佳御(亮黑)(GH7-1103)漆面保护膜",
    R8: "睿御(R8-1201)漆面保护膜",
    G7: "佳御(G7-1101)漆面保护膜",
    CC: "雅彩(CC-01-3101)汽车彩绘膜",
  },
  productCategory: {
    ppf: "车衣",
    paint: "彩绘",
  },

  vehiclePhaseBrand: "选品牌",
  vehiclePhaseModel: "选车型",
  vehicleHubTitle: "选择车辆",
  vehicleHubDesc: "选择品牌和车型后，系统将自动识别车身类型",
  vehicleHubBrandEmpty: "请选择品牌",
  vehicleHubModelEmpty: "请先选择品牌",
  vehicleHubModelPlaceholder: "请选择车型",
  vehiclePickerBack: "返回",
  vehicleFlowLabel: "车辆选择流程",
  vehicleFlowModelHint: "请选择车型",
  changeBrandHint: "点击可更换品牌",
  livePrice: "参考报价",
  saveScreenshot: "保存长图",
  screenshotSaved: "长图已保存",
  screenshotPreviewHint: "长按图片可保存到相册",
  screenshotPreviewTitle: "报价长图预览",
  screenshotPreviewClose: "关闭预览",
  screenshotPreviewPrev: "上一张",
  screenshotPreviewNext: "下一张",
  screenshotSegmented: "内容较长，已生成 {count} 张图片，请逐张长按保存",
  screenshotFailed: "保存失败，请重试",
  screenshotTimeout: "生成超时，请稍后重试",
  capturingScreenshot: "正在生成长图",
  capturingScreenshotHint: "正在渲染页面内容，请稍候…",
  capturingScreenshotSlice: "正在生成第 {current}/{total} 张…",
  capturingScreenshotSaving: "即将完成，正在准备预览…",
  notSelected: "未选",
  partSelected: "已选",
  partsSelectedGroup: "已选（{count}）",
  partsNotSelectedGroup: "未选（{count}）",
  allInstallParts: "装贴部位明细",

  parts: {
    引擎盖: "引擎盖",
    车顶: "车顶",
    后尾箱盖: "后尾箱盖",
    左后叶子板: "左后叶子板",
    右后叶子板: "右后叶子板",
    前左叶子板: "前左叶子板",
    前右叶子板: "前右叶子板",
    左后门: "左后门",
    右后门: "右后门",
    左前门: "左前门",
    右前门: "右前门",
    前杠: "前杠",
    后杠: "后杠",
    左侧裙边: "左侧裙边",
    右侧裙边: "右侧裙边",
    左后视镜: "左后视镜",
    右后视镜: "右后视镜",
  },
};
